import React, { FC, useEffect } from "react";
import { useForm } from "react-hook-form";

import BaseModal from "components/common/BaseModal/BaseModal";
import { IBaseModalProps } from "core/types/elements/IModal";
import { toggleInvalidInput, validationResolver } from "core/helpers";
import { IUser, TFormChangeEmail } from "core/types/base/IUser";
import { changeEmailSchema } from "core/helpers/ValidationSchemas";

interface IProps extends IBaseModalProps<TFormChangeEmail> {
  user: IUser;
}

const ChangeUserEmailModal: FC<IProps> = ({ onClose, showModal, user, onSave, modalTitle }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<IUser>({
    resolver: validationResolver(changeEmailSchema),
  });

  useEffect(() => reset({ email: user.email }), [user, showModal]);

  const onFormSubmit = (formData: TFormChangeEmail) => {
    if (onSave) {
      onSave({
        id: user.id,
        email: formData.email,
      });
    }
  };

  const modalBody = () => (
    <form className="row" autoComplete="off">
      <div className="form-group col-12 mb-3">
        <label className="required" htmlFor="email">
          Email
        </label>
        <input
          type="text"
          className={`shadow-sm form-control ${toggleInvalidInput(!!errors?.email)}`}
          autoComplete="off"
          {...register("email")}
        />
      </div>
    </form>
  );
  return (
    <BaseModal
      modalTitle={modalTitle}
      onClose={onClose}
      onCancel={onClose}
      showModal={showModal}
      modalBody={modalBody()}
      onSave={handleSubmit(onFormSubmit)}
      cancelActionBtnText="Close"
      successBtnText="Save"
      className="change-email"
    />
  );
};

export default ChangeUserEmailModal;
